import { PayloadAction, createSlice } from "@reduxjs/toolkit";

import { MetricsState } from "../types/metrics";
import { setClusterAndOrgAction as setClusterAndOrg } from "./current";

const initialState: MetricsState = {
  routeId: "",
};

const slice = createSlice({
  name: "metrics",
  initialState,
  reducers: {
    setRouteId(state: MetricsState, action: PayloadAction<string>): void {
      state.routeId = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(setClusterAndOrg, (state) => {
      state.routeId = "";
    });
  },
});

export const { reducer, actions } = slice;
export const { setRouteId } = actions;
